var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"coupons"},[_c('h3',[_vm._v(_vm._s(_vm.$$FormData.title || '积分兑换券/码'))]),_c('div',{staticClass:"coupon"},[_c('strong',[_vm._v("¥10")]),_vm._m(0),_c('span',{style:({background: _vm.$$FormData.theme_color || '#202020'})},[_vm._v("兑换")])]),_c('small',[_vm._v("当前接入现有积分兑券活动，不新建独立兑换码商品")])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("积分兑换优惠券"),_c('p',[_vm._v("100积分 · 满100元可用")])])
}]

export { render, staticRenderFns }